import { useState } from "react";

interface AvatarProps {
  name: string;
  imageUrl?: string | null;
  size: number;
}

export function Avatar({ name, imageUrl, size }: AvatarProps) {
  const [errored, setErrored] = useState(false);
  const initial = name.charAt(0).toUpperCase();
  const style = { width: size, height: size };

  if (imageUrl && !errored) {
    return (
      <img
        src={imageUrl}
        alt={name}
        style={{ ...style, objectFit: "cover" as const }}
        className="rounded-full"
        referrerPolicy="no-referrer"
        onError={() => setErrored(true)}
      />
    );
  }

  return (
    <div
      style={{ ...style, fontSize: size * 0.4 }}
      className="rounded-full bg-stone-300 dark:bg-stone-600 text-stone-700 dark:text-stone-200 flex items-center justify-center font-semibold"
    >
      {initial}
    </div>
  );
}
